module.exports = __webpack_public_path__ + "bg.jpg?2365d8eaeddf625986251a0d4e2aea1e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.jpg
// module id = 774
// module chunks = 0